/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import StructureOptionsData from '@Services/StructureOptionsData';
import StructureContainers from '@Services/StructureContainers';
import PropTypes from 'prop-types';
import './StructureOptionsBadges.scss';
import { connect } from 'react-redux';
import { selectedOptionsNameValueObjectsArray as selectedOptionsNameValueObjectsArraySelector } from '@Containers/StructureOptions/StructureOptionsSelecors';
import { updateStructureOptionsDialog as updateStructureOptionsDialogAction } from '@Containers/StructureOptions/StructureOptionsDialog/StructureOptionsDialogActions';
import { fetchAndCreateInitialOptionsCopy as fetchAndCreateInitialOptionsCopyAction } from '@Containers/StructureOptions/StructureOptionsActions';
import { ButtonWithIcon } from '@els/els-react--button';

function StructureOptionsBadges({
  id,
  updateStructureOptionsCallback,
  onSavedOptionsChange = () => {},
  structureOptions,
  savedOptions,
  openStructureOptionsDialog,
  fetchAndCreateInitialOptionsCopy,
  source,
  onStructureOptionClick,
}) {
  const BADGES_IN_ONE_LANE = 3;
  const [badges, setBadges] = useState([]);
  const [ellipsisView, setEllipsisView] = useState(false);
  const [firstBadge, setFirstBadge] = useState(null);
  const [lastBadge, setLastBadge] = useState(null);

  function updateBadges(data) {
    const newBadges = StructureOptionsData.calculateBadges(data);
    setBadges(newBadges);

    if (newBadges.length > BADGES_IN_ONE_LANE) {
      setEllipsisView(true);
      setFirstBadge(newBadges[0]);
      setLastBadge(newBadges[newBadges.length - 1]);
    } else {
      setEllipsisView(false);
    }
  }

  async function updateStructureOptions(optionsList) {
    onSavedOptionsChange(optionsList);
    StructureOptionsData.restoreOptions(optionsList).then(updateBadges);
    await StructureContainers.updateContainerOptions(id, optionsList).catch(Logger.reject);

    if (typeof updateStructureOptionsCallback === 'function') {
      updateStructureOptionsCallback();
    }
  }

  useEffect(() => {
    updateStructureOptions(savedOptions);
  }, [savedOptions]);

  const initialize = async () => {
    if (structureOptions && !savedOptions) {
      fetchAndCreateInitialOptionsCopy(id, structureOptions.length ? structureOptions : undefined).catch(Logger.error);
    } else {
      StructureContainers.getContainerOptions(id)
        .then((data) => {
          fetchAndCreateInitialOptionsCopy(id, data && data.length ? data : undefined);
        })
        .catch(Logger.error);
    }
  };

  useEffect(() => {
    initialize();
  }, []);

  const openOptionsModal = () => {
    openStructureOptionsDialog({ id });
  };

  const handleClick = () => {
    if (source === 'querybuilder' && onStructureOptionClick) {
      onStructureOptionClick();
    } else {
      openOptionsModal();
    }
  };

  const buttonText = () =>
    (!ellipsisView && badges.map((badge) => <span key={badge}>{badge}</span>)) ||
    (!!ellipsisView && <span>{firstBadge}</span>) ||
    (!!ellipsisView && <span className="ellipsis-tag">...</span>) ||
    (!!ellipsisView && <span>{lastBadge}</span>);

  return (
    <ButtonWithIcon
      sprite="Edit"
      iconRight
      id="querybuilder-editstructureconfig-button"
      type="link"
      className="edit-structure-icon"
      onClick={handleClick}>
      {buttonText()}
    </ButtonWithIcon>
  );
}

const mapStateToProps = (state, ownProps) => ({
  savedOptions: selectedOptionsNameValueObjectsArraySelector(state, ownProps),
});

const mapDispatchToProps = {
  openStructureOptionsDialog: updateStructureOptionsDialogAction,
  fetchAndCreateInitialOptionsCopy: fetchAndCreateInitialOptionsCopyAction,
};

StructureOptionsBadges.propTypes = {
  id: PropTypes.string,
  onSavedOptionsChange: PropTypes.func,
  structureOptions: PropTypes.array,
  savedOptions: PropTypes.array,
  openStructureOptionsDialog: PropTypes.func,
  fetchAndCreateInitialOptionsCopy: PropTypes.func,
  updateStructureOptionsCallback: PropTypes.func,
  source: PropTypes.string,
  onStructureOptionClick: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(StructureOptionsBadges);
